import PropTypes from 'prop-types';
import React from 'react';

import { base64Prefix } from 'shared/constants';
import ModalAlert from 'shared/ui/Modal/ModalAlert';
import ModalImageCropper from 'shared/ui/Modal/ModalImageCropper';
import { findEntityTypeByTypeKey } from 'shared/functions';
import { ImageDto } from '@eva/types/dto';

import defaultAvatar from 'assets/images/no-user-image.gif';
import defaultLogo from 'assets/images/no-company.png';
import { requestBackend } from 'utils/request';

import SpinnerSmall from '../Spinner/SpinnerSmall';

type Props = {
  avatar?: ImageDto;
  entityId?: number;
  entitiesType: string;
  submitPath?: string;
  className?: string;

  personMode?: boolean;
  readOnly?: boolean;
  disablePermission?: boolean;
  permissionEntityType?: string;
};

type State = {
  avatar?: ImageDto;
  uploading?: boolean;
  hover?: boolean;
};

const canEditImageArr = ['companies', 'jobs', 'dashboards', 'candidates'];
export class EntityImage extends React.Component<Props, State> {
  unmounted: boolean;

  modalImageCropper?: ModalImageCropper;
  modalAlert?: ModalAlert;

  state: State = {};

  UNSAFE_componentWillMount() {
    this.setAvatar(this.props.avatar);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { avatar } = nextProps;
    if (this.props.avatar !== avatar) {
      this.setAvatar(avatar);
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  setAvatar(avatar) {
    if (this.unmounted) {
      return;
    }
    this.setState({ avatar });
  }

  openCropper() {
    const { avatar } = this.props;

    this.modalImageCropper.open(avatar.url, this.imageSaverPromise).then((updatedAvatar) => {
      if (this.unmounted) {
        return;
      }
      if (updatedAvatar) {
        this.setAvatar(updatedAvatar);
      }
      this.setState({
        uploading: false,
      });
    });
  }

  imageSaverPromise = (dataUrl) => {
    const { entityId, entitiesType, submitPath } = this.props;
    const { endpointPath } = findEntityTypeByTypeKey(entitiesType as any);

    this.setState({
      uploading: true,
    });
    const requestData = {
      method: 'POST',
      body: JSON.stringify({
        filename: `avatar${Date.now()}.webp`,
        content: dataUrl.replace(base64Prefix, ''),
      }),
    };
    return requestBackend(submitPath || `${endpointPath}/${entityId}/avatar`, requestData).then((updatedAvatar) => {
      if (!this.unmounted) {
        this.setAvatar(updatedAvatar);
      }
      return updatedAvatar;
    });
  };

  render() {
    const { isAllowedOperation } = this.context;
    const { entitiesType, entityId, className, personMode, readOnly, disablePermission, permissionEntityType } =
      this.props;
    const { avatar, uploading } = this.state;

    // @ts-expect-error
    const { entityType } = findEntityTypeByTypeKey(entitiesType);

    const permissionPrefix = permissionEntityType || entityType;

    if (!isAllowedOperation(`${permissionPrefix}-avatar-view`)) {
      return null;
    }

    const defaultImage = personMode ? defaultAvatar : defaultLogo;
    const rootClassName = `${className || ''} ${personMode ? 'user-avatar-crop' : 'company-img-crop'}`;
    const editAllowed = !readOnly && (disablePermission || isAllowedOperation(`${permissionPrefix}-avatar-update`));

    const img = (
      <img src={(avatar && avatar.url) || defaultImage} alt={translate(`Entity ${personMode ? 'avatar' : 'logo'}`)} />
    );

    if (!entityId || !canEditImageArr.includes(entitiesType)) {
      return <div className={rootClassName}>{img}</div>;
    }

    return (
      <div
        className={rootClassName}
        onMouseEnter={() => editAllowed && this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onClick={() => editAllowed && this.openCropper()}
      >
        <ModalAlert ref={(ref) => (this.modalAlert = ref)} />
        <ModalImageCropper ref={(ref) => (this.modalImageCropper = ref)} />
        {editAllowed && (
          <div className="options-block">
            <div className="text-nowrap">
              <button type="button" className="btn btn-sm btn-box-tool">
                {uploading ? <SpinnerSmall /> : <i className="lnr lnr-pencil" />}
              </button>
            </div>
          </div>
        )}
        {img}
      </div>
    );
  }
}

// @ts-expect-error: contextTypes
EntityImage.contextTypes = {
  isAllowedOperation: PropTypes.func.isRequired,
};
